import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=508151c8"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=508151c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports